import { Subject } from 'rxjs'

const favFundItemsSubject = new Subject()

function nextByAddFav(favItemsCount) {
  favFundItemsSubject.next(favItemsCount)
}

const fundsCountInfoSubject = new Subject()

function nextByGetFundsCountInfo(fundsCountInfo) {
  fundsCountInfoSubject.next(fundsCountInfo)
}

export { favFundItemsSubject, nextByAddFav, fundsCountInfoSubject, nextByGetFundsCountInfo }
